<svg viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 10.719L8.422 5.058L0 0V10.719Z" fill="currentColor"/>
</svg>
